module.exports = __webpack_public_path__ + "bin/1687d0263f511c67016de34e9a7e2e9c.jpg";